var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("transition", { attrs: { name: "upload-progress-fade" } }, [
        _c("div", { staticClass: "upload-progress" }, [
          _c("div", { staticClass: "upload-mask" }),
          _c(
            "div",
            { staticClass: "status-progress-inner" },
            [
              _c("div", { staticClass: "title-progress" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.titleText)),
                ]),
                _c(
                  "div",
                  { staticClass: "progress" },
                  [
                    _c("el-progress", {
                      attrs: {
                        percentage: _vm.percentage,
                        status: _vm.status,
                        "show-text": false,
                        "stroke-width": 5,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { type: "danger", plain: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(_vm._s(_vm.btnLabel))]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }